import Reflux from 'reflux';

export default Reflux.createActions({
	/** toggle visibility of user dialog box
	 * meant to be used by toolbar
	 */
	toggle: {},
	/** hide ie. close user dialog box */
	close: {},
	/** log a user in
	 * @param{String} name	user's name
	 * @param{String} pw	user's password
	 */
	login: {},
	/** log user out
	 *
	 */
	logout: {},
	/** set if user wants to see prices or not
	 * @param{Boolean} showPrices show prices if true (and allowed to) else don't show prices
	 */
	showPrices: {}
});
